<template>
  <div id="AboutMeImage1" style="z-index: 2;" :class="sectionClass">
    <img
      id="AboutMeImg1"
      ref="target"
      class="content"
      src="/static/about-me/s33.webp"
    />
    <StickMe name="3" size="10" left="20" top="11" uk-parallax="x: 20%" />
    <StickMe name="3" size="10" left="62" top="21" uk-parallax="x: 20%" />
    <StickMe name="3" size="26" left="90" top="16" uk-parallax="x: 100%" />
    <StickMe
      id="MouseTrigger"
      style="z-index: 0;"
      name="1"
      size="20"
      left="17"
      top="33"
      uk-parallax="x: 100%"
    />
    <StickMe
      style="z-index: 0;"
      name="31"
      size="10"
      left="10"
      top="39"
      uk-parallax="x: 80%"
    />

    <StickMe
      style="z-index: 0;"
      name="30"
      size="15"
      left="84"
      top="33"
      uk-parallax="target: #BeeTrigger; y: 120%, -30%; scale: 0, 1"
    />
    <StickMe
      id="BeeTrigger"
      style="z-index: 0;"
      name="32"
      size="18"
      left="72"
      top="41"
    />
    <StickMe
      name="35"
      size="15"
      left="32"
      top="59"
      uk-parallax="target: #MouseTrigger; x: -500%"
    />
    <StickMe name="34" size="6" left="12" top="61" />
    <StickMe name="40" size="16" left="22" top="68" />
    <StickMe name="39" size="16" left="21" top="62" />
    <StickMe name="41" size="8" left="33" top="67" />

    <StickMe
      name="36"
      size="13"
      left="72"
      top="55"
      uk-parallax="target: #BeeTrigger; x: 450%"
    />
    <StickMe name="37" size="13" left="75" top="61" />
    <StickMe name="38" size="11" left="95" top="60" />
    <StickMe name="42" size="18" left="88" top="67" />

    <StickMe name="3" size="10" left="36" top="92" uk-parallax="x: 30%" />
  </div>
</template>

<script>
import { isMobile } from '@/helpers'
import StickMe from './StickMe.vue'

export default {
  components: { StickMe },
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
    emitHide() {
      let target = this.$refs.target
      let targetRect = target.getBoundingClientRect()

      let startAt = 210

      if (targetRect.top < startAt) {
        this.$emit('hide', true)
      } else {
        this.$emit('hide', false)
      }
    },
    onScroll() {
      this.emitHide()
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: false })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>

<style lang="scss" scoped>
.section {
  scale: 0.8;
  padding: 30% 0%;
}

.sectionMobile {
  scale: 1;
  width: 90%;
  padding: 30% 0%;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeImage1.vue